<template>
  <div class="act-apl">
    <div class="form-ipt">
      <div class="input">
        <div class="reject" v-if="worksType == 1 || worksType == 2">
          <p>修改到期时间：{{ rejectUpdTime }}</p>
          <p>驳回理由：{{ rejectReason }}</p>
        </div>
        <van-field v-if="model == 0 || subject == '个人' || subject == '集体创作'" readonly clickable
          name="playerVal" input-align="right" required :value="zoneName" label="所在地区" :error="subjectList.length === 0"
          placeholder="选择地区" @click="
            worksType == 1 ||
              worksType == 2 || id ? ''
              : (provincesShow = true)
            " error-message-align="right" :error-message="validate.fieldMsg.playerVal" />
        <van-popup v-model="provincesShow" position="bottom">
          <van-picker value-key="areaName" show-toolbar :columns="provincesArr" @confirm="provincesAdd"
            @cancel="provincesShow = false" />
        </van-popup>
        <van-field v-if="formData.zoneId" input-align="right" readonly clickable name="subject" required
          :value="subject" label="参赛主体" placeholder="请选择主体" @click="formData.workId ? '' : (subjectShow = true)"
          error-message-align="right" :error-message="validate.fieldMsg.subject" />
        <van-popup v-model="subjectShow" position="bottom">
          <van-picker show-toolbar :columns="subjectList" @confirm="subjectAdd" @cancel="subjectShow = false" />
        </van-popup>
        <van-field v-if="subject == '个人'" readonly clickable name="playerVal" input-align="right" required
          :value="player" label="参赛选手" :error="playerColumns.length === 0" :placeholder="playerColumns.length ? '选择选手' : '请先在个人中心添加学生'
            " @click="getSelectingPlayers" error-message-align="right" :error-message="validate.fieldMsg.playerVal"
          :style="{ marginBottom: '20px' }" />
        <van-popup v-model="playerShow" position="bottom">
          <van-picker show-toolbar :columns="playerColumns" @confirm="playerConfirm" @cancel="playerShow = false" />
        </van-popup>

        <van-field v-if="subject == '集体创作'" input-align="right" required label="团体成员" error-message-align="right">
          <template #input>
            <van-button round type="primary" @click="addUser" size="small">添加</van-button>
          </template>
        </van-field>
        <div class="overallWrap-Left" style="background-color: #fff; max-width: 100vw">
          <div class="photo-upload" v-for="(item, index) in formData.list" :key="'t' + index">
            <van-tag style="padding: 10px" :show="true" closeable size="medium" type="primary" color="#f2f2f2"
              text-color="#333" @close="closeTag(index)">
              {{ item.name }}（{{ item.phone }}）
            </van-tag>
          </div>
        </div>
        <van-field v-if="formData.zoneId" input-align="right" readonly clickable name="majorVal" required :value="major"
          label="选择专业" placeholder="请选择专业"
          @click="worksType == 1 || worksType == 2 ? '' : (majorShow = true)" error-message-align="right"
          :error-message="validate.fieldMsg.majorVal" />
        <van-popup v-model="majorShow" position="bottom">
          <van-picker show-toolbar :columns="majorColumns" @confirm="majorConfirm" @cancel="majorShow = false" />
        </van-popup>
        <van-field v-if="formData.zoneId" input-align="right" readonly clickable name="groupVal"
          required :value="group" label="选择组别" placeholder="请选择组别" @click="groupShowFn" error-message-align="right"
          :error-message="validate.fieldMsg.groupVal" />
          <van-popup v-model="groupShow" position="bottom">
            <van-picker show-toolbar :columns="groupColumns" @confirm="groupConfirm" @cancel="groupShow = false" />
          </van-popup>

        <van-field label-width="100" input-align="right" clickable v-model="formData.schoolName" label="就读学校"
          placeholder="请输入就读学校" error-message-align="right" />

        <template v-if="activityId == 28">
          <van-field input-align="right" readonly clickable name="groupVal" required :value="formData.province"
            label="选择地区" placeholder="选择地区" @click="provinceShowFn = true" error-message-align="right"
            :error-message="validate.fieldMsg.groupVal" />
          <van-popup v-model="provinceShowFn" position="bottom">
            <van-picker show-toolbar :columns="areaListData" @confirm="getprovinceShowFn"
              @cancel="provinceShowFn = false" />
          </van-popup>
        </template>

        <van-field v-if="formData.mainBodyType == 1" input-align="right" clickable name="mail" v-model="formData.mail"
          label="邮箱账号" placeholder="请输入邮箱便于接受通知" error-message-align="right" />

        <van-field input-align="right" clickable name="phone" required v-model="formData.phone" label="手机号码"
          placeholder="请输入手机便于接受通知" error-message-align="right" maxlength="11"
          :error-message="validate.reg_verify_err_msg.phone || validate.fieldMsg.phone" @change="validate.tel('phone')"
          :style="{ marginBottom: '20px' }" />
        <div v-for="(time, index) in formList" :key="'f' + index">
          <van-field v-if="time.type == 'TEXT'" input-align="right" clickable :required="time.validate.required == 1"
            v-model="formValue[index].value" :label="time.name"
            :placeholder="time.attribute && time.attribute.description" error-message-align="right" :style="{
              marginBottom: index + 1 == formList.length ? '20px' : '0px'
            }" />
          <div v-if="time.type == 'RADIO'">
            <van-field input-align="right" readonly clickable :required="time.validate.required == 1"
              :value="formValue[index].name" :label="time.name"
              :placeholder="time.attribute && time.attribute.description" @click="time.popShow = true"
              error-message-align="right" :style="{
                marginBottom: index + 1 == formList.length ? '20px' : '0px'
              }" :error-message="validate.fieldMsg.majorVal" />
            <van-popup v-model="time.popShow" position="bottom">
              <van-picker show-toolbar :columns="time.value" @confirm="
                (res) => {
                  formValue[index].value = res.value;
                  formValue[index].name = res.text;
                  time.popShow = false;
                }
              " @cancel="time.popShow = false" />
            </van-popup>
          </div>
        </div>
        <van-field input-align="right" clickable name="photo_title" required v-model="formData.photo_title" label="作品名称"
          maxlength="12" placeholder="请输入12字内作品名称" error-message-align="right"
          :error-message="validate.fieldMsg.photo_title" />
        <van-field v-if="(model == 0 && institutionName) || subject == '集体创作' || isWriteTeacherInfo == 1"
          :required="teacherInfoRequired == 1" input-align="right" clickable v-model="teacherName" label="指导老师"
          maxlength="12" placeholder="请输入指导老师" error-message-align="right" />
        <van-field v-if="(model == 0 && institutionName) || subject == '集体创作' || isWriteTeacherInfo == 1"
          :required="teacherInfoRequired == 1" label-width="100" input-align="right" clickable v-model="teacherTel"
          label="指导老师手机号" maxlength="12" placeholder="请输入指导老师手机号" error-message-align="right" />
        <van-field v-if="formData2.unitName && subject == '集体创作'" input-align="right" clickable required name="teacher"
          v-model="formData2.teacherName" label="指导老师" :disabled="isInst" placeholder="请输入报名服务单位指导老师姓名"
          error-message-align="right" :error-message="validate.fieldMsg.teacher" />
        <van-field v-if="formData2.unitName && subject == '集体创作'" input-align="right" clickable required
          name="teacher_phone" :disabled="isInst" v-model="formData2.teacherPhone" label="指导老师手机号"
          placeholder="请输入指导老师手机号" />

        <van-field input-align="right" clickable name="photo_desc" required v-model="formData.photo_desc" autosize
          rows="4" type="textarea" maxlength="300" label="作品描述" placeholder="请输入作品描述，如创作动机、作品构思等" show-word-limit
          error-message-align="right" :error-message="validate.fieldMsg.photo_desc" />
        <template v-if="formData.imgsArr && formData.imgsArr.length > 0">
          <div v-for="(time, index) in formData.imgsArr" :key="index">
            <van-field input-align="right" label-class="affixs-label" label="作品文件" required error-message-align="right"
              :error-message="validate.fieldMsg.imgs">
              <template #label>
                <span class="custom-title">作品{{
                  time.fileType == 1
                    ? "图片"
                    : time.fileType == 2
                      ? "音频"
                      : time.fileType == 3
                        ? "视频"
                        : time.fileType == 4
                          ? "文档"
                          : ""
                }}文件</span>
                <div class="custom-tit">
                  <span v-if="time.formatInfo">{{ time.formatInfo }}格式不超过300M</span>
                </div>
              </template>
            </van-field>
            <div class="photo-upload">
              <van-uploader :accept="time.formatInfo" v-model="time.photo_file_list" :max-count="1"
                :before-read="(file) => photoBeforeRead(file, index)" />
            </div>
          </div>
        </template>
        <van-field v-if="sourceFileMust" input-align="right" label-class="affixs-label" label="源文件附件"
          :required="sourceFileMust" error-message-align="right" :error-message="validate.fieldMsg.sourceFile">
          <template #label>
            <span class="custom-title">源文件附件</span>
            <span class="custom-tit">(如HUA、PSD、AI等源文件,且不超过300M)
            </span>
          </template>
        </van-field>
        <div class="file-upload" v-if="sourceFileMust">
          <van-uploader v-model="photo_affix_list" :max-count="1" :before-read="affixBeforeRead" accept="">
            <template #preview-cover>
              <div class="preview-cover van-ellipsis">
                {{ photo_affix_list[0].name }}
              </div>
            </template>
          </van-uploader>
        </div>
      </div>
      <!--  -->
      <div v-if="isCollection == 1">
        <sign-title title="收件信息" />
        <van-field input-align="right" clickable name="receivingUser" required v-model="formData.receivingUser"
          label="收件人" maxlength="12" placeholder="请输入收件人" error-message-align="right"
          :error-message="validate.fieldMsg.receivingUser" />
        <van-field input-align="right" clickable name="receivingPhone" required v-model="formData.receivingPhone"
          label="手机号" maxlength="12" placeholder="请输入收件人手机号" error-message-align="right"
          :error-message="validate.fieldMsg.receivingPhone" @change="validate.tel('receivingPhone')" />
        <van-field input-align="right" clickable name="receivingCode" required v-model="formData.receivingCode"
          label="邮编" placeholder="请输入邮编" error-message-align="right" :error-message="validate.fieldMsg.receivingCode" />
        <van-field input-align="right" clickable name="receivingDetailAddress" required
          v-model="formData.receivingDetailAddress" label="收件地址" placeholder="请输入收件地址" error-message-align="right"
          :error-message="validate.fieldMsg.receivingDetailAddress" />
      </div>
      <div class="tips">
        <div class="tip">
          <van-checkbox v-model="promise" icon-size="16px" @click="handleAgreementClick('originalCommitment')" />
          <p>我已阅读并同意《<span @click.stop="openAgreement('originalCommitment')">作品原创承诺书</span>》</p>
        </div>
        <div class="tip">
          <van-checkbox v-model="mandate" icon-size="16px" @click="handleAgreementClick('authorizationLetter')" />
          <p>我已阅读并同意《<span @click.stop="openAgreement('authorizationLetter')">作品授权书</span>》</p>
        </div>
      </div>
      <div class="submit" v-if="modifiableType == 1 && worksType == 0">
        <van-button size="large" @click="submitFn"
          color="linear-gradient(to right, #5DD682, #5AFF8E)" :disabled="btndis">提交</van-button>
      </div>
      <div class="submit" v-if="modifiableType == 0 || worksType == 1 || worksType == 2">
        <van-button size="large" @click="editFn" color="linear-gradient(to right, #5DD682, #5AFF8E)">修改</van-button>
      </div>
    </div>


    <van-popup v-model="applySuccess" position="right" :style="{ height: '100%', width: '100%' }">
      <div class="apply-success">
        <div class="tip-info">
          <img v-if="(signUpSuccessConfig.posterUrl || '').length > 0" style="width: 200px; height: 200px;"
            :src="signUpSuccessConfig.posterUrl" alt="" />
          <img v-else style="width: 200px; height: 200px;" src="../../assets/images/home/apply-success.png" alt="" />
          <p>

            {{
              (signUpSuccessConfig.promptText && signUpSuccessConfig.promptText.length > 0) ?
                signUpSuccessConfig.promptText :
                isLabelPrint == 1
                  ? "恭喜您，报名成功！" : "恭喜！您已提交成功。请关注评审结果"
            }}

          </p>
        </div>
        <div class="successTips" v-if="isLabelPrint == 1">
          <div>
            1.报名成功后，绘画及书法类作品须提交原件至组委会，不提供参赛作品原件者不得参与比赛评审;
          </div>
          <div>
            2.参赛者提交的原件作品须在作品背面按要求粘贴作品标签；<span @click="getLabel">如何获取并张贴标签？</span>
          </div>
        </div>
        <div class="overallCenter know" @click="getknow">我知道了</div>
      </div>
    </van-popup>
    <!-- 协议弹窗组件 -->
    <AgreementPopup
      v-model="agreementPopup"
      :title="getCurrentAgreementTitle()"
      :content="getCurrentAgreementContent()"
      :read-time="getCurrentReadTime()"
      @confirm="onAgreementConfirm"
    />
    <SignaturePopup
      v-model="signaturePopup"
      :agreements="signatureAgreements"
      :activity-id="activityId"
      :baby-id="formData.playerVal"
      @confirm="onSignatureConfirm"
      @close="onSignatureClose"
    />

    <van-dialog v-model="showAdd" :before-close="listAddUser" title="新增团体成员" show-cancel-button>
      <div style="padding: 20px 10px">
        <van-field label-width="100" input-align="right" clickable name="name" required v-model="name" label="姓名"
          maxlength="12" placeholder="请输入姓名" error-message-align="right" />
        <van-field label-width="100" input-align="right" clickable name="phone" required v-model="phone" label="手机号"
          maxlength="12" placeholder="请输入手机号" error-message-align="right" />
        <van-field name="radio" label="身份证号类型" required input-align="right">
          <template #input>
            <van-radio-group v-model="idCardType" direction="horizontal">
              <van-radio name="0">内地</van-radio>
              <van-radio name="1">港澳台及外籍</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field label-width="100" input-align="right" clickable name="phone" required v-model="idCardNo" label="身份证号"
          maxlength="18" placeholder="请输入身份证号" error-message-align="right" />

        <van-field v-if="idCardType == 1" input-align="right" readonly required clickable name="cardType" label="出生日期"
          v-model="birthday" placeholder="点击选择出生日期" error-message-align="right" @click="showBirthday = true" />
        <van-popup v-model="showBirthday" position="bottom">
          <van-datetime-picker type="date" title="选择年月日" :min-date="minDate" :max-date="new Date()"
            @cancel="showBirthday = false" @confirm="getbirthday" />
        </van-popup>
        <van-field v-if="idCardType == 1" readonly disabled input-align="right" clickable name="age" v-model="age"
          type="digit" label="年龄" placeholder="选择出生日期自动生成" />
        <van-field v-if="idCardType == 1" input-align="right" readonly required clickable :value="sex" name="sex"
          label="学生性别" placeholder="点击选择性别" @click="showPicker = true" />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar @cancel="showPicker = false" :columns="[
            { text: '男', value: 1 },
            { text: '女', value: 2 }
          ]" @confirm="
            (e) => {
              sex = e.text;
              (sexVal = e.value), (showPicker = false);
            }
          " />
        </van-popup>
      </div>
    </van-dialog>
    <van-dialog v-model="showCode" title="温馨提示" @confirm="handleSureCode">
      <div style="padding: 20px 10px">
        <div style="text-align: center;">您的编号已经更新</div>
        <div style="text-align: center;">{{ newTransactionId }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import SignTitle from "@/components/pub/SignTitle.vue";
import AgreementPopup from "@/components/pub/AgreementPopup.vue";
import SignaturePopup from "@/components/pub/SignaturePopup.vue";
import { validate } from "@/utils/mixin/validate";
import { areaList } from "@vant/area-data";
import { getjsapisignature } from "@/utils/api/wx";
import {
  activityEnroll,
  updWorks,
  getCurrentActivityMajor,
  sendReadingCode,
  getAllProvinces,
  getProvinceByGeo
} from "@/utils/api/home";
import {
  getWorksDetails,
  getAllUserBaby,
  uploadFile,
  getswActivityDetail
} from "@/utils/api/user";
import { checkUploadFile, getfileTypeArr } from "@/utils/tool";
import { getGrowAge } from "@/utils/yearOld";
import { localStorageGetItem, localStorageSetItem } from "@/utils/auth";
import { getLocation } from "@/utils/location";
export default {
  mixins: [validate],
  components: {
    "sign-title": SignTitle,
    AgreementPopup,
    SignaturePopup
  },

  data() {
    return {
      showCode: false,
      newTransactionId: '',
      // 地区
      areaList,
      areaListData: [],
      id: "",
      // 机构名称id
      institutionName: "",
      // 指导老师
      teacherName: "",
      teacherTel: "",
      // 是否收件
      isCollection: "",
      // 文件上传提示
      formatInfo: "",
      // 活动id
      activityId: "",
      model: 2,
      // 团体添加学生字段
      name: "",
      phone: "",
      idCardNo: null,
      idCardType: "0",
      showBirthday: false,
      birthday: null,
      age: null,
      minDate: new Date(),
      showPicker: false,
      sex: "",
      sexVal: "",
      // 团队弹框
      showAdd: false,
      // 主体
      subjectShow: false,
      subjectList: [
        // { text: "个人", value: "1" },
        // { text: "团体", value: "2" }
      ],
      // 团队还是个人
      subject: "",
      // 显示选择参赛选手
      playerShow: false,
      // 选手名称
      player: null,
      // 赛区
      zoneName: null,
      // 选手列表
      playerColumns: [],

      // 专业组别集合列表
      CurrentActivityMajor: {},

      // 显示选择专业
      majorShow: false,
      // 专业名称
      major: null,
      // 专业列表
      majorColumns: [],

      // 显示选择组别
      groupShow: false,
      // 组别名称
      group: null,
      // 组别列表
      groupColumns: [],

      // 作品文件
      photo_file_list: [],
      // 作品源文件
      photo_affix_list: [],
      // 同意承诺书
      promise: false,
      // 同意授权书
      mandate: false,
      formData2: {
        // name: "",
        // age: null,
        // school: "",
        // organizationVal: null,
        // teacher: "",
        // teacher_phone: ""
      },
      signUpSuccessConfig: {},
      // 提交数据
      formData: {
        // 团队还是个人
        mainBodyType: null,
        schoolName: "",
        list: [],
        receivingUser: null,
        receivingPhone: null,
        receivingDetailAddress: null,
        receivingCode: null,
        playerVal: null,
        majorVal: null,
        groupVal: null,
        // 联系方式
        phone: "",
        imgsArr: [],
        mail: null,
        photo_title: null,
        photo_desc: null,
        sourceFile: null,
        // 省
        province: null,
        // 赛区
        zoneName: null,
        zoneId: ""
      },
      // 地区选择弹框
      provinceShowFn: false,

      formDataPhone: "",
      // 是否报名成功
      applySuccess: false,
      // 作品id
      worksId: null,
      // 需要源文件
      sourceFileMust: false,
      modifiableType: 1, // 1 不可修改  0 可修改
      worksType: 0, // 0 正常 1 被驳回 2修改后  3 报名失败
      rejectReason: "",
      rejectUpdTime: "",
      btndis: false,
      isInst: false,
      // 赛区省数组
      provincesShow: false,
      provincesArr: [],
      // 是否出现 打印标签:改为是否出现提示
      isLabelPrint: 0,
      // 自定义字段
      formList: [],
      formValue: [],
      // 是否开启填写教师信息 1-开启 0-不开启
      isWriteTeacherInfo: 0,
      teacherInfoRequired: 0,

      authorizationLetter:{ //作品授权书
        content:'',
        forceReadOnly:0,
        requireSign:0,
      },

      originalCommitment:{ // 作品原创承诺书
        content:'',
        forceReadOnly:0,
        requireSign:0,
      },
      // 协议弹窗相关
      agreementPopup: false,
      currentAgreementType: '',
      signaturePopup: false,
      signatureAgreements: [],
      signatureUrls: {
        originalCommitment: '',
        authorizationLetter: ''
      },
      pendingSubmitData: null,
      pendingSubmitAction: '',
    };
  },
  watch: {
    'formData.imgsArr': {
      handler(newVal) {
        this.$nextTick(() => {
          // 确保视图更新
        });
      },
      deep: true
    }
  },
  async mounted() {
    this.areaListData = [];
    for (let i in this.areaList.province_list) {
      this.areaListData.push({ text: areaList.province_list[i], value: i });
    }
    this.validate.setFormDataKey("formData");
    this.id = this.$route.query.id;
    let activityId = this.$route.query.activityId;
    let infos = JSON.parse(window.localStorage.getItem("active_infos_data"));
    activityId = activityId || (infos && infos.id);
    await getswActivityDetail(activityId).then((res) => {
      if (res.code == 20000) {
        infos = res.data;
        console.log('activity detail', res.data);
        this.signUpSuccessConfig = infos.signUpSuccessConfig ;
        console.log('this.signUpSuccessConfig',this.signUpSuccessConfig);
        this.authorizationLetter = infos.authorizationLetter || {};
        this.originalCommitment = infos.originalCommitment || {};
        if (res.data.activityTeacherConfig) {
          this.isWriteTeacherInfo = res.data.activityTeacherConfig.isWriteTeacherInfo;
          this.teacherInfoRequired = res.data.activityTeacherConfig.teacherInfoRequired;
        }
      }
    });
    this.subjectList = [
      { text: "个人", value: "1" },
    ];
    if (infos) {
      this.getzdingyi(infos.formList);
      this.activityId = infos.id;
      this.model = infos.model;
      this.isCollection = infos.isCollection;
      this.isLabelPrint = infos.isLabelPrint;
    }
    this.formData = {
      mainBodyType: 1,
      majorVal: null,
      mail: null,
      phone: null,
      photo_title: null,
      photo_desc: null,
      imgsArr: [],
      sourceFile: null,
      groupVal: null
    };
    // 正式站id 是31的 强制状态 为mode==1的显示
    if (infos.id == 31 || infos.id == 40 || infos.id == 37) {
      this.model = 1;
    }
    if (infos.id !== 28) {
      this.formData.province = this.$store.state.addressInfos.province;
    }
    this.formData.zoneName = this.$store.state.addressInfos.province;
    if (this.model == 1) {
      this.formData = {
        teacherName: null,
        teacherPhone: null,
        list: [],
        ...this.formData
      };
      this.subject = "个人";
    } else {
      this.subject = "";
    }
    if (this.isCollection == 1) {
      this.formData = {
        receivingUser: null,
        receivingPhone: null,
        receivingDetailAddress: null,
        receivingCode: null,
        ...this.formData
      };
    }
    if (this.id) {
      this.activityId = "";
      await this.testDataInput();
    } else {
      const userInfo = this.$store.state.userInfo;
      this.formData.phone = userInfo.code;
      this.getPageSelectInfo();
    }
    this.AllProvinces();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "Login" && this.activityId) {
      next({ name: "HomeIndex" });
    } else {
      next(); // 注意：这边next必须要写
    }
  },
  methods: {
    getzdingyi(data) {
      let formList = data.map((res) => {
        res.popShow = false;
        if (res.type == "RADIO") {
          res.value = res.value.map((k) => {
            return {
              text: k.title,
              value: k.id
            };
          });
        }
        return res;
      });
      this.formList = formList;
      this.formValue = data.map((res) => {
        return { formId: res.id, value: "", name: "" };
      });
    },
    /**
     * @description: 获取省数据
     * @author: wangxiaoheng
     */
    AllProvinces() {
      getAllProvinces(this.activityId).then((res) => {
        if (res.success) {
          this.provincesArr = res.data;
          if(!this.id){
            this.getprovinceID()
          }
        }
      });
    },
    // 根据经纬度设置省id
    async getprovinceID (){
      const res = await getLocation();
      if (res.success) {
        getProvinceByGeo(res.longitude,res.latitude).then((res) => {
          if (res.success) {
            if(res.data&&res.data.areaId){
              const hasId = this.provincesArr.some(item => item.id == res.data.areaId);
              if(hasId){
                this.provincesAdd({areaName:res.data.areaName,id:res.data.areaId});
              }
            }
          }
        });
      } else {
        console.log(res.type, res.message);
      }
    },
    // 年龄限制
    ageLimit(val) {
      if (parseInt(val) > 30) {
        this.age = 30;
      }
      if (parseInt(val) < 1) {
        this.age = 1;
      }
    },
    getbirthday(date) {
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.birthday = Y + M + D;
      this.age = getGrowAge(this.birthday).gapYear;
      this.ageLimit(this.age);
      this.showBirthday = false;
    },
    // 获取作品信息
    async testDataInput() {
      await getWorksDetails(this.id).then((res) => {
        if (res.success) {
          let info = res.data;
          this.major = info.majorName;
          this.group = info.groupName;
          this.activityId = info.activityId;
          this.isCollection = info.isCollection;
          this.player = info.babyName;
          this.province = info.province;
          this.zoneName = info.zoneName;
          if (info.institutionName && info.memo1 && info.memo2) {
            this.isInst = true;
          }
          this.photo_affix_list = [
            {
              url: info.sourceFile,
              name: info.sourceFile,
              status: "done"
            }
          ];
          this.modifiableType = info.modifiableType;
          this.rejectUpdTime = info.rejectUpdTime;
          this.rejectReason = info.rejectReason;
          this.worksType = info.worksType;
          let teacher = {
            list: info.list
          };
          let rece = {
            receivingUser: info.receivingUser,
            receivingPhone: info.receivingPhone,
            receivingDetailAddress: info.receivingDetailAddress,
            receivingCode: info.receivingCode
          };
          this.formData2 = {
            unitName: info.institutionName,
            babyName: info.babyName,
            organizationVal: null,
            teacherName: info.memo1,
            teacherPhone: info.memo2
          }
          let formData = {
            schoolName: info.schoolName,
            mainBodyType: info.mainBodyType,
            majorVal: info.majorId,
            photo_title: info.name,
            photo_desc: info.synopsis,
            province: info.province,
            imgsArr: getfileTypeArr(info.imgs),
            sourceFile: info.sourceFile,
            workId: this.id,
            phone: info.telNoHidden,
            zoneId: info.zoneId,
            zoneName: info.zoneName,
            groupVal: info.groupId,
          };
          this.formDataPhone = formData.phone;
          this.formTeacherPhone = info.memo2;
          let typeInfo = {
            playerVal: info.babyId,
            mail: info.email
          };
          this.subject = info.mainBodyType == 1 ? "个人" : "集体创作";
          if (info.mainBodyType == 1) {
            this.formData = { ...formData, ...typeInfo };
          } else {
            this.formData = { ...formData, ...teacher };
          }
          if (this.isCollection == 1) {
            this.formData = { ...this.formData, ...rece };
          }
          if ((this.formData2.unitName && this.subject == '集体创作') || (this.model == 0 && this.institutionName) || (this.activityId == 31 && this.subject == '集体创作') || this.isWriteTeacherInfo == 1) {
            if (this.model === 0 || this.activityId == 31) {
              this.institutionName = info.institutionName;
              this.teacherName = info.memo1;
              this.teacherTel = info.memo2;
            }
          } else {
            // delete this.formData.schoolName
          }
          this.getzdingyi(info.activityFromList, true);
          if (info.fromList && info.fromList.length > 0) {
            this.formValue = info.fromList.map((k) => {
              let data = {
                formId: k.fromId,
                value: k.value,
                name: k.valueText
              };
              return data;
            });
          }
          this.getPageSelectInfo();
          this.getCurrentActivityMajor()
        }
      });
    },
    // 获取页面信息
    getPageSelectInfo() {
      getAllUserBaby().then((res) => {
        if (res.success) {
          this.playerColumns = res.data.map((e) => {
            return {
              text: e.name,
              value: e.id,
              list: e.babyInstitutionMd
            };
          });
        }
      });
    },
    // 获取专业 组别
    getCurrentActivityMajor() {
      getCurrentActivityMajor({
        activityId: this.activityId,
        channelId: ''
      }).then((res) => {
        console.log('获取专业 组别', res)
        if (res.success) {
          this.CurrentActivityMajor = res.data;
          let data = res.data.personalEnroll;
          if (res.data.groupEnroll && res.data.groupEnroll.length > 0) {
            let type = false;
            this.subjectList.map((e) => {
              if (e.value == "2") {
                type = true;
              }
            });
            if (!type) {
              this.subjectList.push({
                text: "集体创作",
                value: "2",
              })
            }
          } else {
            this.subjectList = [{ text: "个人", value: "1" }]
          }
          this.gethandle(data)
        }
      });
    },
    // 处理组别专业
    gethandle(data) {
      data = data.map((e) => {
        return {
          text: e.majorName,
          value: e.majorId,
          gruop: e.childGroup,
          sourceFileMust: e.typeId == 1,
          fileTypeList: e.fileTypeList
        };
      });
      this.majorColumns = data
      for (let item of this.majorColumns) {
        if (item.value == this.formData.majorVal) {
          this.sourceFileMust = item.sourceFileMust;
          this.groupColumns = item.gruop.map((e) => {
            return {
              text: e.groupName,
              value: e.groupId
            };
          });
        }
      }
      console.log('专业列表', this.majorColumns)
    },
    // end
    addUser() {
      if(this.formData.list&&2<=this.formData.list.length&&this.activityId==68){
        this.$root.$toast.fail("团队报名最多报名两个");
        return
      }
      let date = new Date();
      let Y = date.getFullYear();
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.minDate = new Date(Y - 30, M, D);
      this.idCardNo = null;
      this.idCardType = null;
      this.showBirthday = false;
      this.birthday = null;
      this.age = 0;
      this.showPicker = false;
      this.sex = "";
      this.sexVal = "";
      this.phone = "";
      this.name = "";
      this.showAdd = true;
    },
    listAddUser(action, done) {
      if (action === "confirm") {
        // 确认
        if (!this.name || !this.phone || !this.idCardNo) {
          this.$root.$toast.fail("请填写信息");
          done(false); // 关闭提⽰框
          return;
        }
        if (this.idCardType == 1) {
          if (!this.birthday || !this.age || !this.sex) {
            this.$root.$toast.fail("请填写信息");
            done(false); // 关闭提⽰框
            return;
          }
        }
        let data = {
          name: this.name,
          phone: this.phone,
          idCardNo: this.$cryptojs.encryptionBase64(this.idCardNo),
          idCardType: this.idCardType
        };
        for (let index in this.formData.list) {
          let time = this.formData.list[index]
          if (time.idCardNo == data.idCardNo) {
            this.$root.$toast.fail("请勿重复添加学生");
            done(false);
            return;
          }
        }
        if (data.idCardType == 1) {
          data.birthday = this.birthday;
          data.age = this.age;
          data.sex = this.sexVal;
        }
        this.formData.list.push(data);
        done(); // 关闭提⽰框
      } else if (action === "cancel") {
        // 取消
        done(); // 关闭提⽰框
      }
    },
    closeTag(e) {
      this.formData.list.splice(e, 1);
    },
    /**
     * @description: 赛区选择
     * @param {*} data  选中数据
     * @author: wangxiaoheng
     */
    provincesAdd(data) {
      this.province = data.areaName;
      this.zoneName = data.areaName;
      if (this.activityId !== 28) {
        this.formData.province = data.areaName;
      }
      this.formData.zoneName = data.areaName;
      this.formData.zoneId = data.id;
      this.getCurrentActivityMajor()
      this.provincesShow = false;
    },
    // 参赛选手确定
    playerConfirm(item) {
      this.player = item.text;
      this.formData.playerVal = item.value;
      this.playerShow = false;
    },
    // 地区选择
    getprovinceShowFn(item) {
      this.formData.province = item.text;
      this.provinceShowFn = false;
    },
    // 主体确认
    subjectAdd(item) {
      this.player = "";
      this.major = "";
      this.group = "";
      this.photo_affix_list = [];
      let rece = {
        receivingUser: null,
        receivingPhone: null,
        receivingDetailAddress: null,
        receivingCode: null
      };
      let teacher = {
        teacherName: null,
        teacherPhone: null,
        list: [],
      };
      let grop = {
        playerVal: null,
        mail: null
      };
      let formData = {
        zoneName: this.formData.zoneName,
        zoneId: this.formData.zoneId,
        province: this.formData.province || null,
        imgsArr: [],
        majorVal: null,
        groupVal: null,
        mainBodyType: null,
        photo_title: null,
        photo_desc: null,
        sourceFile: null
      };
      if (item.value == 2) {
        this.formData = { ...formData, ...teacher };
      }
      if (item.value == 1) {
        this.formData = { ...formData, ...grop };
      }
      if (this.isCollection == 1) {
        this.formData = { ...formData, ...rece };
      }
      this.formData.mainBodyType = item.value;
      this.subject = item.text;
      this.subjectShow = false;
      if (item.text == '集体创作') {
        this.gethandle(this.CurrentActivityMajor.groupEnroll)
      } else {
        this.gethandle(this.CurrentActivityMajor.personalEnroll)
      }
    },
    // 专业确定
    majorConfirm(item) {
      this.major = item.text;
      this.formData.majorVal = item.value;
      this.majorShow = false;
      this.group = "";
      this.formData.groupVal = "";
      this.sourceFileMust = item.sourceFileMust;
      this.formatInfo = "";
      this.formData.sourceFile = "";
      this.formData.imgsArr = [];
      for (let k in item.fileTypeList) {
        let kType = item.fileTypeList[k];
        let formatInfo = "";
        if (kType == 1) {
          formatInfo = "image/jpeg,image/png,image/jpg";
        } else if (kType == 2) {
          formatInfo = ".mp3,.wav,.ogg,.mpeg";
        } else if (kType == 3) {
          formatInfo = ".mp4,.avi,.mov";
        } else if (kType == 4) {
          formatInfo = ".doc,.docx";
        }
        this.formData.imgsArr.push({
          fileName: "",
          fileUrl: "",
          url: "",
          fileType: kType,
          formatInfo: formatInfo,
          photo_file_list: []
        });
      }
      this.photo_affix_list = [];
      this.groupColumns = item.gruop.map((e) => {
        return {
          text: e.groupName,
          value: e.groupId
        };
      });
    },
    // 打开专业组别
    groupShowFn() {
      if (this.worksType == 1 || this.worksType == 2) {
        return;
      }
      if (!this.formData.majorVal) {
        this.$root.$toast.fail("请选择活动专业");
        return;
      }
      this.groupShow = true;
    },
    // 组别确定
    groupConfirm(item) {
      this.group = item.text;
      this.formData.groupVal = item.value;
      this.groupShow = false;
    },
    // 图片上传
    photoBeforeRead(file, index) {
      let imgsArr = this.formData.imgsArr[index];
      console.log(this.formData.imgsArr, imgsArr)
      const pass = checkUploadFile(
        {
          file,
          size: 300,
          type: imgsArr.fileType,
          typestr: imgsArr.formatInfo
        },
        (err) => {
          this.$root.$toast.fail(err);
        }
      );
      if (!pass) {
        return false;
      }
      this.formData.imgsArr[index].photo_file_list = [
        {
          message: "上传中...",
          status: "uploading"
        }
      ];
      this.formData.imgsArr[index].url = "";
      let upimgobj = new FormData();
      upimgobj.append("file", file);
      uploadFile(upimgobj, this.activityId).then(({ success, data }) => {
        console.log('返回', success, data)
        if (success) {
          this.formData.imgsArr[index].photo_file_list = [
            {
              status: "done",
              url: data.fileUrl
            }
          ];
          this.$forceUpdate();
          return success;
        } else {
          this.formData.imgsArr[index].photo_file_list = [
            {
              message: "上传失败，请重新上传",
              status: "failed",
              url: ""
            }
          ];
          this.$forceUpdate();
          return success;
        }
      });
    },
    // 源文件上传
    affixBeforeRead(file) {
      const fileName = file.name;
      const pass = checkUploadFile(
        { file, size: 300, type: 1, typestr: -1 },
        (err) => {
          this.$root.$toast.fail(err);
        }
      );
      if (!pass) {
        return false;
      }
      this.photo_affix_list = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: fileName
        }
      ];
      let upfileobj = new FormData();
      upfileobj.append("file", file);

      uploadFile(upfileobj, this.activityId).then(({ success, data }) => {
        if (success) {
          this.photo_affix_list = [
            {
              url: data.fileUrl, //
              name: fileName,
              status: "done"
            }
          ];
          this.formData.sourceFile = data.fileUrl;
          return success;
        } else {
          this.photo_affix_list = [
            {
              url: "",
              message: "上传失败，请重新上传",
              status: "failed"
            }
          ];
          return success;
        }
      });
    },
    // 处理协议勾选点击
    handleAgreementClick(type) {
      const agreementData = type === 'authorizationLetter' ? this.authorizationLetter : this.originalCommitment;

      if (type === 'originalCommitment') {
        // 作品原创承诺书
        if (this.promise) {
          // 如果要勾选
          this.promise = false;
          if (agreementData.forceReadOnly === 1) {
            // 强制阅读模式：打开弹窗
            this.currentAgreementType = type;
            this.agreementPopup = true;
          } else {
            // 非强制阅读模式：直接勾选
            this.$nextTick(() => {
              this.promise = true;
            });
          }
        }
      } else if (type === 'authorizationLetter') {
        // 作品授权书
        if (this.mandate) {
          // 如果要勾选
          this.mandate = false;
          if (agreementData.forceReadOnly === 1) {
            // 强制阅读模式：打开弹窗
            this.currentAgreementType = type;
            this.agreementPopup = true;
          } else {
            // 非强制阅读模式：直接勾选
            this.$nextTick(() => {
              this.mandate = true;
            });
          }
        }
      }
    },
    // 打开协议弹窗（点击协议文字）
    openAgreement(type) {
      this.currentAgreementType = type;
      this.agreementPopup = true;
    },
    // 协议确认回调
    onAgreementConfirm() {
      if (this.currentAgreementType === 'originalCommitment') {
        this.promise = true;
      } else if (this.currentAgreementType === 'authorizationLetter') {
        this.mandate = true;
      }
    },
    // 获取当前协议内容
    getCurrentAgreementContent() {
      if (this.currentAgreementType === 'originalCommitment') {
        return this.originalCommitment.content || '';
      } else if (this.currentAgreementType === 'authorizationLetter') {
        return this.authorizationLetter.content || '';
      }
      return '';
    },
    // 获取当前协议标题
    getCurrentAgreementTitle() {
      if (this.currentAgreementType === 'originalCommitment') {
        return '作品原创承诺书';
      } else if (this.currentAgreementType === 'authorizationLetter') {
        return '作品授权书';
      }
      return '协议';
    },
    // 获取当前协议的强制阅读时间（forceReadOnly为0时返回0，表示不强制）
    getCurrentReadTime() {
      if (this.currentAgreementType === 'originalCommitment') {
        return this.originalCommitment.forceReadOnly === 1 ? 5 : 0;
      } else if (this.currentAgreementType === 'authorizationLetter') {
        return this.authorizationLetter.forceReadOnly === 1 ? 5 : 0;
      }
      return 0;
    },
    getRequiredSignatureAgreements() {
      const agreements = [];
      if (this.originalCommitment.requireSign == 1 ) {
        agreements.push({
          key: 'originalCommitment',
          type: 1,
          title: '作品原创承诺书'
        });
      }
      if (this.authorizationLetter.requireSign == 1) {
        agreements.push({
          key: 'authorizationLetter',
          type: 2,
          title: '作品授权书'
        });
      }
      return agreements;
    },
    fillSignatureUrls(data) {
      console.log('=== 填充签署链接到提交数据 ===');
      data.originalCommitment = this.signatureUrls.originalCommitment || '';
      data.authorizationLetter = this.signatureUrls.authorizationLetter || '';
      console.log('originalCommitment:', data.originalCommitment);
      console.log('authorizationLetter:', data.authorizationLetter);
      return data;
    },
    submitAfterSignature(action, data) {
      this.fillSignatureUrls(data);
      if (action === 'edit') {
        this.submitEditData(data);
      } else {
        this.submitEnrollData(data);
      }
    },
    handleBeforeSubmit(action, data) {
      const requiredAgreements = this.getRequiredSignatureAgreements();
      console.log('=== 提交前签署检查 ===');
      console.log('originalCommitment:', JSON.stringify(this.originalCommitment));
      console.log('authorizationLetter:', JSON.stringify(this.authorizationLetter));
      console.log('需要签署的协议:', requiredAgreements);
      console.log('已签署链接:', JSON.stringify(this.signatureUrls));

      const needSignature = requiredAgreements.some((item) => !this.signatureUrls[item.key]);

      if (requiredAgreements.length > 0 && needSignature) {
        console.log('>>> 打开签署弹窗 <<<');
        this.pendingSubmitAction = action;
        this.pendingSubmitData = data;
        this.signatureAgreements = requiredAgreements;

        // 使用 $nextTick 确保 DOM 更新后再设置弹窗状态
        this.$nextTick(() => {
          this.signaturePopup = true;
          console.log('signaturePopup 已设置为:', this.signaturePopup);
        });
        return;
      }
      console.log('无需签署或已全部签署，直接提交');
      this.submitAfterSignature(action, data);
    },
    onSignatureConfirm({ url, agreements }) {
      console.log('=== 签署确认回调 ===');
      console.log('返回链接:', url);
      console.log('协议列表:', JSON.stringify(agreements));

      // 将同一个签名链接赋值给所有需要签署的协议
      if (agreements && Array.isArray(agreements)) {
        agreements.forEach((item) => {
          if (item && item.key) {
            this.signatureUrls[item.key] = url;
            console.log(`已设置 ${item.key} 的签署链接:`, url);
          }
        });
      }

      const data = this.pendingSubmitData;
      const action = this.pendingSubmitAction;

      // 清理临时数据
      this.pendingSubmitData = null;
      this.pendingSubmitAction = '';

      console.log('最终签署链接:', JSON.stringify(this.signatureUrls));
      console.log('准备提交，action:', action);

      if (data && action) {
        this.submitAfterSignature(action, data);
      } else {
        console.error('缺少提交数据或动作类型');
        this.btndis = false;
      }
    },
    onSignatureClose() {
      this.btndis = false;
      this.pendingSubmitData = null;
      this.pendingSubmitAction = '';
    },
    submitEditData(data) {
      updWorks(data).then((res) => {
        console.log(res.data)
        if (res.success) {
          // 报名成功
          this.newTransactionId = res.data.newTransactionId || ''
          if (this.newTransactionId.length > 0) {
            this.showCode = true
          } else {
            this.$root.$toast.fail("修改成功");
            this.$router.go(-1);
          }
        }
      });
    },
    submitEnrollData(data) {
      activityEnroll(data).then((res) => {
        if (res.success) {
          // 报名成功
          this.worksId = res.data.id;
          this.applySuccess = true;
          setTimeout(() => {
            this.btndis = false;
          }, 2000);
        } else {
          setTimeout(() => {
            this.btndis = false;
          }, 2000);
        }
      });
    },
    // 修改信息
    async editFn() {
      if (this.model == 1) {
        if (this.subject == "集体创作") {
          if (this.formData.list.length <= 0) {
            this.$root.$toast.fail("请添加集体创作成员");
            return;
          } else if (this.formData.list.length == 1) {
            this.$root.$toast.fail("一个人请选择个人报名");
            return;
          }
        }
      }
      if (!this.promise) {
        this.$root.$toast.fail("请先阅读并同意 《作品原创承诺书》");
        return;
      }
      if (!this.mandate) {
        this.$root.$toast.fail("请先阅读并同意 《作品授权书》");
        return;
      }
      for (let k in this.formData.imgsArr) {
        let imgsArr = this.formData.imgsArr[k];
        if (imgsArr.photo_file_list.length < 1) {
          this.$root.$toast.fail("请上传" + imgsArr.formatInfo + "格式文件");
          return;
        }
        if (imgsArr.photo_file_list[0].status == "uploading") {
          this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
          return;
        }
      }
      if (
        (this.photo_file_list.length > 0 &&
          this.photo_file_list[0].status === "uploading") ||
        (this.photo_affix_list.length > 0 &&
          this.photo_affix_list[0].status === "uploading")
      ) {
        this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
        return;
      }
      // 验证数据
      const dataValidate = () => {
        return new Promise((res) => {
          for (let key in this.formData) {
            if (key === "sourceFile") {
              if (this.sourceFileMust) {
                let pass = this.validate.isNull(key);
                if (!pass) {
                  this.$root.$toast.fail("请选择源文件附件");
                  res(false);
                } else {
                  res(true);
                }
              } else {
                res(true);
              }
            } else {
              let pass = this.validate.isNull(key);
              if ((key == 'list' || key == 'teacherName' || key == 'teacherPhone') && this.subject == '个人') {
                pass = true
              }
              if (!pass) {
                res(false);
              }
              this.$forceUpdate();
            }
          }
        });
      };
      const result = await dataValidate();
      if (this.isCollection == 1) {
        if (
          !this.formData.receivingUser ||
          !this.formData.receivingPhone ||
          !this.formData.receivingCode ||
          !this.formData.receivingDetailAddress
        ) {
          return;
        }
      }
      if (!this.formData.zoneId) {
        this.$root.$toast.fail("请选择赛区");
        return;
      }
      if (!result) {
        this.validate.errMsgPopup();
        this.validate.errMsgEmpty();
        return;
      } else {
        this.btndis = true;
        let {
          unitName,
          teacherName,
          teacherPhone,
          list,
          receivingUser,
          receivingPhone,
          receivingDetailAddress,
          receivingCode,
          mainBodyType,
          playerVal,
          majorVal,
          groupVal,
          mail,
          phone,
          photo_title,
          province,
          zoneId,
          zoneName,
          photo_desc,
          sourceFile,
          workId,
          imgsArr,
          schoolName
        } = this.formData;
        let imgs = [];
        imgsArr.map((K) => {
          if (K.photo_file_list[0].url) {
            imgs.push(K.photo_file_list[0].url);
          }
        });
        for (let i in this.formValue) {
          let kdata = this.formValue[i];
          let tdata = this.formList[i];
          if (!kdata.value && tdata.validate && tdata.validate.required == 1) {
            return this.$root.$toast.fail(
              this.formList[i].attribute.description
            );
          }
        }
        const p = {
          schoolName: schoolName,
          unitName: unitName || this.formData2.unitName,
          list,
          receivingUser,
          receivingPhone,
          receivingDetailAddress,
          receivingCode,
          mainBodyType,
          babyId: playerVal,
          email: mail,
          groupId: groupVal,
          imgs,
          majorId: majorVal,
          name: photo_title,
          sourceFile,
          synopsis: photo_desc,
          tel: phone == this.formDataPhone ? "" : phone,
          workId,
          activityId: this.activityId,
          province: province,
          zoneId,
          zoneName: zoneName,
          fromList: this.formValue,
          originalCommitment:'', // 作品原创承诺书 签字图片链接
          authorizationLetter:'',// 作品授权书  签字图片链接
          // source报名来源 ow官网 weixin微信 douyin抖音
          // source: localStorage.getItem("port") == "douyin" ? "douyin" : "weixin"
        };

        if ((this.model == 0 && this.institutionName) || this.subject == '集体创作' || this.isWriteTeacherInfo == 1) {
          p.teacherName = this.teacherName
          p.teacherTel = this.teacherTel
        } else if (this.formData2.unitName && subject == '集体创作') {
          p.teacherName = this.formData2.teacherName
          p.teacherTel = this.formData2.teacherTel
        } else {
          if (teacherName || this.formData2.teacherName || this.teacherName) {
            p.teacherName = teacherName || this.formData2.teacherName || this.teacherName
          }
          if (teacherPhone || this.formData2.teacherPhone || this.teacherTel) {
            p.teacherTel = teacherPhone || this.formData2.teacherPhone || this.teacherTel
          }
          p.teacherTel = p.teacherPhone == this.formTeacherPhone ? "" : p.teacherPhone;
        }
        this.handleBeforeSubmit('edit', p);
      }
    },

    handleSureCode() {
      this.$root.$toast.fail("修改成功");
      this.$router.go(-1);
    },

    // 提交投稿信息
    async submitFn() {
      if (this.model == 1) {
        if (this.subject == "集体创作") {
          if (this.formData.list.length <= 0) {
            this.$root.$toast.fail("请添加集体创作成员");
            return;
          } else if (this.formData.list.length == 1) {
            this.$root.$toast.fail("一个人请选择个人报名");
            return;
          }
        }
      }
      if (this.teacherInfoRequired == 1 && (!this.teacherTel || !this.teacherName)) {
        this.$root.$toast.fail("请填写指导老师信息");
        return;
      }
      for (let k in this.formData.imgsArr) {
        let imgsArr = this.formData.imgsArr[k];
        if (imgsArr.photo_file_list.length < 1) {
          this.$root.$toast.fail("请上传" + imgsArr.formatInfo + "格式文件");
          return;
        }
        if (imgsArr.photo_file_list[0].status == "uploading") {
          this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
          return;
        }
      }
      if (!this.promise) {
        this.$root.$toast.fail("请先阅读并同意 《作品原创承诺书》");
        return;
      }
      if (!this.mandate) {
        this.$root.$toast.fail("请先阅读并同意 《作品授权书》");
        return;
      }
      if (
        (this.photo_file_list.length > 0 &&
          this.photo_file_list[0].status === "uploading") ||
        (this.photo_affix_list.length > 0 &&
          this.photo_affix_list[0].status === "uploading")
      ) {
        this.$root.$toast.fail("图片或文件正在上传，请稍后再试。");
        return;
      }
      // 验证数据
      const dataValidate = () => {
        return new Promise((res) => {
          for (let key in this.formData) {
            if (key === "sourceFile") {
              if (this.sourceFileMust) {
                let pass = this.validate.isNull(key);
                if (!pass) {
                  this.$root.$toast.fail("请选择源文件附件");
                  res(false);
                } else {
                  res(true);
                }
              } else {
                res(true);
              }
            } else {
              let pass = this.validate.isNull(key);
              if ((key == 'list'|| key == 'teacherName' || key == 'teacherPhone') && this.subject == '个人') {
                pass = true
              }
              if (!pass) {
                res(false);
              }
              this.$forceUpdate();
            }
          }
        });
      };
      const result = await dataValidate();
      if (this.isCollection == 1) {
        if (
          !this.formData.receivingUser ||
          !this.formData.receivingPhone ||
          !this.formData.receivingCode ||
          !this.formData.receivingDetailAddress
        ) {
          return;
        }
      }
      if (!this.formData.zoneId ) {
        this.$root.$toast.fail("请选择赛区");
        return;
      }
      if (!result) {
        this.validate.errMsgPopup();
        this.validate.errMsgEmpty();
        return;
      } else {
        this.btndis = true;
        const {
          unitName,
          teacherName,
          teacherPhone,
          list,
          receivingUser,
          receivingPhone,
          receivingDetailAddress,
          receivingCode,
          mainBodyType,
          playerVal,
          majorVal,
          groupVal,
          mail,
          phone,
          photo_title,
          province,
          zoneName,
          zoneId,
          photo_desc,
          imgsArr,
          sourceFile,
          schoolName
        } = this.formData;
        let imgs = [];
        imgsArr.map((K) => {
          if (K.photo_file_list[0].url) {
            imgs.push(K.photo_file_list[0].url);
          }
        });
        for (let i in this.formValue) {
          let kdata = this.formValue[i];
          let tdata = this.formList[i];
          if (!kdata.value && tdata.validate && tdata.validate.required == 1) {
            return this.$root.$toast.fail(
              this.formList[i].attribute.description
            );
          }
        }
        const p = {
          schoolName: schoolName,
          unitName: unitName || this.formData2.unitName,
          teacherName: teacherName || this.formData2.teacherName || this.teacherName,
          teacherTel: teacherPhone || this.formData2.teacherPhone || this.teacherTel,
          list,
          receivingUser,
          receivingPhone,
          receivingDetailAddress,
          receivingCode,
          mainBodyType,
          babyId: playerVal,
          email: mail,
          groupId: groupVal,
          imgs,
          majorId: majorVal,
          name: photo_title,
          sourceFile,
          synopsis: photo_desc,
          tel: phone,
          activityId: this.activityId,
          province: province,
          zoneId,
          zoneName: zoneName,
          fromList: this.formValue,
          originalCommitment:'', // 作品原创承诺书 签字图片链接
          authorizationLetter:'',// 作品授权书  签字图片链接
          // source报名来源 ow官网 weixin微信 douyin抖音
          source: localStorage.getItem("port") == "douyin" ? "douyin" : "weixin"
        };
        this.handleBeforeSubmit('enroll', p);
      }
    },
    /**
     * @description: 获取标签流程
     * @author: wangxiaoheng
     */
    getLabel() {
      this.$router.push("/getLabel");
    },
    /**
     * @description: 查询赛区地址
     * @author: wangxiaoheng
     */
    getDivision() {
      this.$router.push("/home/affairsQuery");
    },
    getknow() {
      this.$router.go(-1);
    },
    getaddStudent() {
      this.$router.push("/player/AddBaby");
    },
    getSelectingPlayers() {
      if (
        this.modifiableType == 0 ||
        this.worksType == 1 ||
        this.worksType == 2
      ) {
      } else {
        if (this.playerColumns.length === 0) {
          this.getaddStudent();
        } else {
          this.playerShow = true;
        }
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.act-apl {
  min-height: 100vh;
  width: 100%;
  max-width: 10rem;
  // padding: 0 20px;
  background-color: #f9f9f9;

  .form-ipt {
    padding-bottom: 60px;

    .input {
      .reject {
        padding: 10px;
        color: red;

        p {
          margin: 5px 0;
          font-size: 14px;
        }
      }

      .van-cell {
        &::after {
          border: none;
        }
      }

      // padding: 0 20px;
      .van-cell__title {
        text-align: left;
      }

      .photo-upload,
      .file-upload {
        padding: 0 10px;
        background-color: #fff;
      }
    }

    .tips {
      padding-left: 100px;
      margin-top: 20px;

      .tip {
        display: flex;
        line-height: 22px;

        p {
          margin-left: 10px;
          font-size: 12px;
          color: #999;

          span {
            color: rgba(64, 158, 255, 0.7);
          }
        }
      }
    }
  }

  .apply-success {
    height: 100%;
    background-color: #fff;

    .tip-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        margin-top: 55px;
      }

      .van-icon {
        font-size: 52px;
      }

      p {
        font-size: 18px;
        font-weight: 700;
        color: #666;
        margin-top: 14px;
        margin-bottom: 12px;
        padding: 0 40px;
        text-align: center;
      }
    }
  }

  .know {
    width: 209px;
    height: 40px;
    margin: 0 auto;
    margin-top: 30px;
    background: #83e38f;
    border-radius: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffffff;
  }

  .successTips {
    width: 330px;
    background: #f7f7fa;
    border-radius: 5px;
    margin: 0 auto;
    padding: 18px 12px;

    div {
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #404046;
      line-height: 21px;
      margin-top: 20px;
    }

    div:first-child {
      margin-top: 0px;
    }

    span {
      color: #ff7856;
      text-decoration: underline;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";

.act-apl {
  text-align: left;

  .affixs-label {
    width: unset;

    &+.van-field__value {
      display: none;
    }
  }

  .input {
    .van-uploader {
      @include from-upload-style;
    }
  }

  .preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
  }

  .submit {
    margin-top: 20px;
    display: flex;
    justify-content: center;

    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }

  .custom-tit {
    font-size: 12px;
    color: #cccccc;
  }
}

</style>
